module.exports = __webpack_public_path__ + "img/wa_example_list.88bb5779.png";